import React from "react";

import "./CardLogin.css";

const CardLogin = ({ children }) => {
  return (
    <div className="cardPage">
      <div className="cardContainer">{children}</div>
    </div>
  );
};

export default CardLogin;
